import React, { useState, useEffect, useRef, useMemo, createContext, useContext } from 'react';
import styles from './subjectsDetail.module.scss';
import { ApiCore } from '../../api/index';
import { createFromIconfontCN, HistoryOutlined } from '@ant-design/icons';
import defaultAvatar from '../../static/icon/defaultAvatar.svg';
import { ActivityIndicator, Button, DatePickerView, InputItem, List, Modal, Picker, Toast } from 'antd-mobile';
import { UnorderedListOutline } from 'antd-mobile-icons';
import { Dialog } from 'antd-mobile-v5';
import PatientSelfReported from '../patientSelfReported/patientSelfReported'
import SubjectBind from '../subjectBind/subjectBind'
import { useLocation } from 'react-router-dom';
import close from '../../static/icon/close.svg';
// import backBtn from '../../static/icon/backBtn.svg';
import backBtn from '../../static/icon/back_button.png';
import moment from 'moment';
import utils from '../../utils/utils';
import VisitForm from '../visitForm/visitForm';
import icon_audit_already from '../../static/images/icon_audit_already.png';
import icon_audit_remain from '../../static/images/icon_audit_remain.png';
import icon_audit_no_pass from '../../static/images/icon_audit_no_pass.png';
import icon_sign_already from '../../static/images/icon_sign_already.png';
import icon_sign_remain from '../../static/images/icon_sign_remain.png';
import icon_sign_remain1 from '../../static/images/icon_sign_remain1.png';
import icon_sign_no_pass from '../../static/images/icon_sign_no_pass.png';
import warning from '../../static/images/warning.png';
import CaseCollect from '../../pagesDoctor/videoCollect/caseCollect';
import RwdDetail from '../../pagesDoctor/videoCollect/rwdDetail';
import cameraIcon from '../../static/images/upload_camera_icon.png';
import fileIcon from '../../static/images/upload_file_icon.png';
import imgIcon from '../../static/images/upload_img_icon.png';
import email_icon from '../../static/images/email_icon.png';

import OSS from "ali-oss";

import { Document, Page, pdfjs } from 'react-pdf';
import TransoutModal from './transout-modal/TransoutModal';
import Preview from '../../component/preview/Preview';
import Empty from '../../component/empty/Empty';
import CreateFormModal from './create-form-modal';
import TenantConfiguration from '../../utils/tenantConfiguration';
import storageX from '../../utils/storageX';
import { makeUploadName, makeUploadOptions } from '../../component/ocr-autofill/utils';

import SignAgreementLink from '../checkSubject/components/signAgreementLink';
import FormUnlock from './form-unlock';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_2343612_adf3x9c88m9.js',
});

function SubjectsDetail(props: any) {
    const urlParams = utils.getUrlParams();
    let token = sessionStorage.getItem('token');
    let mToken: any = {};
    if (token) {
        try {
            mToken = JSON.parse(token);

        } catch (error) {
            mToken = {};
        }
    }
    let isNewUI = mToken && mToken.tenantConfig && mToken.tenantConfig.enableNewUi;
    const [isOriginPage, setIsOriginPage] = useState<any>(urlParams.isOriginPage || !isNewUI || '');
    //选择的项目
    const [projectType, setProjectType] = useState<any>(urlParams.projectType || '');
    // 项目ID
    const [projectId] = useState<number>(()=> urlParams.projectId);
    // 编码
    const [subjectCode] = useState<string>(()=> props.match.params.id);
    //受试者数据
    const [subjectsData, setSubjectsData] = useState<any>([]);
    //表单数据
    const [formData, setFormData] = useState<any>([]);
    // 患者自报列表
    const [selfReportedList, setSelfReportedList] = useState<any[]>([]);
    // 是否显示患者上报
    const [subjectScaleReportState, setSubjectScaleReportState] = useState<number>(-1);
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //设置当前选中的元素
    const [selectedEle, setSelectedEle] = useState<any>();
    //实际访视日期
    const [visitDate, setVisitDate] = useState<any>();
    //实际访视日期选择弹框是否显示
    const [visitDateModalShow, setVisitDateModalShow] = useState<boolean>(false);
    // 计划访视时间
    const [planDate, setPlanDate] = useState<any>()
    //预约访视日期
    const [appointmentDate, setAppointmentDate] = useState<any>();
    //预约访视日期选择弹框是否显示
    const [appointmentDateModalShow, setAppointmentDateModalShow] = useState<boolean>(false);
    //备注弹框是否显示
    const [remarkModalShow, setRemarkModalShow] = useState(false);
    //备注类型list
    const [remarkTypeList, setRemarkTypeList] = useState<any>([]);
    //当前选中的备注类型
    const [currentRemarkType, setCurrentRemarkType] = useState<any>();
    //备注内容
    const [remarkValue, setRemarkValue] = useState<any>();
    //备注警示类型列表
    const [isWarningList, setIsWarningList] = useState<any>([]);
    //备注是否为警示
    const [remarkIsWarning, setRemarkIsWarning] = useState<any>();
    //显示表单（当前只有一个节点时）
    const [showVisitForm, setShowVisitForm] = useState<Boolean>(false);
    //获取审核失败原因
    const [rejectReasons, setRejectReasons] = useState<any>([]);
    //显示签名按钮
    const [showReSubmitBtn, setShowReSubmitBtn] = useState(true);

    // 实际访视时间
    const [visitModal, setVisitModal] = useState(false);
    // 修改访视时间
    const [currentVisitDate, setCurrentVisitDate] = useState<any>();
    // 访视id
    const [visitId, setVisitId] = useState<any>('');
    const [visit, setVisit] = useState<any>({})
    const [visibleCreateModal, setVisibleCreateModal] = useState(false)

    // 计划访视时间弹窗
    const [planModal, setPlanModal] = useState(false)
    // 修改计划访视时间
    const [currentPlanDate, setCurrentPlanDate] = useState<any>()
    // 计划访视日期二次弹窗
    const [showPlanModal, setShowPlanModal] = useState(false)
    // 计划访视剩余访视次数
    const [remainingVisits, setRemainingVisits] = useState<any>()

    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});
    //上传文件模态框
    const [showUploadModal, setShowUploadModal] = useState(false);
    //查看病例签名modal
    const [showCaseImage, setShowCaseImage] = useState(false);
    //病例签名文件地址
    const [caseImageUrl, setCaseImageUrl] = useState('');

    const [caseFileType, setCaseFileType] = useState('pdf'); //pdf  image
    const [numPages, setNumPages] = useState(1); //pdf文件总页数

    //邮箱地址modal
    const [showEmailModal, setShowEmailModal] = useState(false);
    
    //邮箱地址
    const [emailAddress, setEmailAddress] = useState('');
    // 病例下载地址
    const [casePreviewUrl, setCasePreviewUrl] = useState('');

    const [projectRoleCode, setProjectRoleCode] = useState('');

    //邮箱地址modal
    const [rejectReasonModal, setRejectReasonModal] = useState(false);

    const [rejectReasonList, setRejectReasonList] = useState([])

    const VisitFormRef = useRef<any>(null);
    const [nameSearch, setNameSearch] = useState<any>('');
    const [signUrl, setSignUrl] = useState<any>('');
    const [fileName, setFileName] = useState<any>('');
    const [transoutModalVisible, setTransoutModalVisible] = useState(false)
    const [info, setInfo] = useState<{ bindState: number, reportName: string }>({ bindState: -1, reportName:''});

    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;
    const location = useLocation();

    const configuration = useMemo(()=> ({
        //受试者名称
        targetName: sessionStorage.getItem('targetName') || '受试者',
        // 多恩达医学项目隐藏实际访视日期
        hiddenVisitDate: TenantConfiguration.read<boolean>('hiddenVisitDate'),
    }), [])

    useEffect(() => {
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');
        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }
        setNameSearch(JSON.parse(sessionStorage.getItem('nameSearch') || '0'))

        //缓存路由，便于定向返回
        localStorage.setItem("pathname", location.pathname+location.search)
    }, [])


    useEffect(() => {
        const subjectScaleReportState = JSON.parse(sessionStorage.getItem('toPhotoEditItem') ?? '{}').subjectScaleReportState
        setSubjectScaleReportState(subjectScaleReportState)
        getCaseEmail()
        subjectBindState()
    }, [])

  

    // 返回逻辑处理,针对小程序的地图选点功能返回，做了单独处理，跳转到指定页面，略过小程序地图选择页面
    const goBack = ()=>{
        const formUrl = localStorage.getItem("formUrl")
        if(formUrl){
           props.history.push({ pathname: localStorage.getItem("pathHome") })
           
        }else{
           props.history.go(-1)
        }  
    }

    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;

            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }

    useEffect(() => {
        //设置网页title
        if (projectType === 'VIDEOSOLICIT') {
            document.title = '任务详情';
        } else if (projectType === 'COURSESOLICIT') {
            document.title = '课程详情';
        } else if (projectType === 'CASESOLICIT') {
            document.title = '病例详情';
        } else if (projectType === 'QUESTIONSURVEY') {
            document.title = '问卷详情';
        } else {
            // LISTEDSTYDY
            document.title = `${configuration.targetName}首页`;
        }
        initData();
    }, [])

    const initData = () => {
        let currentState_storage = sessionStorage.getItem('currentState');
        //若有状态
        if (currentState_storage) {
            setLoading(true);
            let currentState = JSON.parse(currentState_storage);
            api.getSubjectdDetail({ id: props.match.params.id }).then(res => {
                if (res.code == '0') {
                    setSubjectsData(res.data);
                    setProjectRoleCode(res.data.roleCode)
                    if (res.data.code) {
                        let _task = res.data.tasks || [];
                        let needReasons = _task.some((val: any) => val.type === 'AuidtFail');
                        needReasons && toGetAuditRejectReasons(res.data.code);
                    }
                    if (currentState.type === 'task') {
                        if (res.data.tasks && res.data.tasks.length > 0) {
                            let index = res.data.tasks.findIndex((i: any) => { return i.type === currentState.key });
                            if (index !== -1) {
                                let ele = document.getElementById(`${currentState.key}_${index}`);
                                if (ele) {
                                    if (index == 1) {
                                        ele.style.backgroundColor = '#fae2a2';
                                    } else {
                                        ele.style.backgroundColor = '#bccef9';
                                    }

                                    ele.style.fontWeight = '700';
                                }
                                setSelectedEle(`${currentState.key}_${index}`);
                                api.getVisitsByType({ subjectCode: res.data.code, type: currentState.key }).then(res => {
                                    if (res.code == '0') {
                                        // 受试者随访量表结果待查看待办事件
                                        if(currentState.key === 'Quest') {
                                            setFormData([])
                                            setSelfReportedList(res.data)    
                                        } else {
                                            setFormData(res.data)
                                            // 待处理事件时, 不显示患者上报
                                            setSelfReportedList([])
                                        }
                                    }
                                    setLoading(false);
                                })
                            }
                            else {
                                getData();
                            }
                        }
                        else {
                            getData();
                        }
                    }
                    else {
                        let ele = document.getElementById(currentState.key);
                        if (ele) {
                            ele.style.backgroundColor = '#bccef9';
                            ele.style.fontWeight = '700';
                        }
                        setSelectedEle(currentState.key);
                        getFormsById(currentState.key);
                    }
                }
            })
        }
        else {
            //获取数据
            getData();
        }
    }

    //初始化数据
    const getData = () => {
        setLoading(true);
        api.getSubjectdDetail({ id: props.match.params.id }).then(res => {
        if (res.code == '0') {
                setSubjectsData(res.data);
                if (res.data.code) {
                    sessionStorage.setItem('caseCode', res.data.code)
                    sessionStorage.setItem('projectRoleCode', res.data.roleCode)
                    sessionStorage.setItem('editModel', res.data.editModel)
                    setProjectRoleCode(res.data.roleCode)

                    let _task = res.data.tasks || [];
                    let needReasons = _task.some((val: any) => val.type === 'AuidtFail');
                    needReasons && toGetAuditRejectReasons(res.data.code);

                    // fix 君实医生把患者改成了未入组则质疑关闭且表单禁用
                    if (['Pass', 'Withdraw'].includes(res.data.state) && res.data.editModel) {
                        sessionStorage.setItem('forceReadonly', 'true')
                    } else {
                        sessionStorage.removeItem('forceReadonly')
                    }
                }
                if (res.data.visits && res.data.visits.length > 0) {
                    let currentVisitByRunning = res.data.visits.find((item: any) => {
                        return item.state == 'Running'
                    })
                    if (currentVisitByRunning) {
                        let ele = document.getElementById(currentVisitByRunning.id);
                        if (ele) {
                            ele.style.backgroundColor = '#bccef9';
                            ele.style.fontWeight = '700';

                        }
                        setSelectedEle(currentVisitByRunning.id);
                        getFormsById(currentVisitByRunning.id, res.data)
                    }
                    else {
                        let currentVisitByWait = res.data.visits.find((item: any) => {
                            return item.state == 'Wait'
                        })
                        if (currentVisitByWait) {
                            let ele = document.getElementById(currentVisitByWait.id);
                            if (ele) {
                                ele.style.backgroundColor = '#bccef9';
                                ele.style.fontWeight = '700';
                            }
                            setSelectedEle(currentVisitByWait.id);
                            getFormsById(currentVisitByWait.id, res.data);
                        }
                        else {
                            let currentVisitByLastComplete = res.data.visits.find((item: any) => {
                                return item.state == 'Complete'
                            })
                            if (currentVisitByLastComplete) {
                                let ele = document.getElementById(currentVisitByLastComplete.id);
                                if (ele) {
                                    ele.style.backgroundColor = '#bccef9';
                                    ele.style.fontWeight = '700';
                                }
                                setSelectedEle(currentVisitByLastComplete.id);
                                getFormsById(currentVisitByLastComplete.id, res.data);
                            }
                        }
                    }
                }

            }
            setLoading(false);
        })
    }

    const toGetAuditRejectReasons = (subjectCode = '') => {
        api.GetAuditRejectReasons({
            subjectCode: subjectCode
        }).then((res: any) => {
            if (res.code == 0) {
                let arr = [];
                let reasons = res.data && res.data.reasons;
                let remark = res.data && res.data.remark;
                if (reasons && reasons.indexOf(';') > 0) {
                    arr = reasons.split(';');
                } else if (reasons) {
                    arr.push(reasons);
                }
                if (remark) {
                    arr.push(remark);
                }
                setRejectReasons(arr);
            }
        })
    }

    //选择访视时间
    const switchVisitTime = (item: any) => {
        switch (item.state) {
            case 'Complete':
                return item.visitDate
            case 'Running':
                return item.visitDate
            case 'Lose':
                return item.appointmentDate ? item.appointmentDate : item.planDate
            case 'Wait':
                return item.appointmentDate ? item.appointmentDate : item.planDate
            default:
                break;
        }
    }
    //选择访视状态对应的icon
    const switchVisitState = (item: any) => {
        // 若节点有质疑
        if (item.question) {
            if (item.lockState == "Complete") {
                return <IconFont type="iconLock_Complete"></IconFont>
            } else {
                switch (item.state) {
                    case 'Complete':
                        return (
                            <React.Fragment>
                                <IconFont type="iconvisit_Question"></IconFont>
                                <IconFont type="iconvisitComplete"></IconFont>
                            </React.Fragment>
                        )
                    case 'Running':
                        return (
                            <React.Fragment>
                                <IconFont type="iconvisit_Question"></IconFont>
                                <IconFont type="iconvisitRunning"></IconFont>
                            </React.Fragment>
                        )
                    case 'Lose':
                        return (
                            <React.Fragment>
                                <IconFont type="iconvisit_Question"></IconFont>
                                <IconFont type="iconvisitLose"></IconFont>
                            </React.Fragment>
                        )
                    case 'Wait':
                        return (
                            <React.Fragment>
                                <IconFont type="iconvisit_Question"></IconFont>
                                <IconFont type="iconvisitWait"></IconFont>
                            </React.Fragment>
                        )
                    default:
                        break;
                }
            }
        }
        // 节点无质疑
        else {
            // console.log(item);

            if (item.formPass == "Complete"||subjectsData.auditState
            == "Pass") {
                return <IconFont type="iconLock_Complete"></IconFont>
            } else {
                switch (item.state) {
                    case 'Complete':
                        return <IconFont type="iconvisitComplete"></IconFont>
                    case 'Running':
                        return <IconFont type="iconjinhangzhongxiangmu"></IconFont>
                    case 'Lose':
                        return <IconFont type="iconvisitLose"></IconFont>
                    case 'Wait':
                        return <IconFont type="iconvisitWait"></IconFont>
                    default:
                        break;
                }
            }

        }
    }

    //根据访视id获取表单数据
    const getFormsById = (id: any, data?: any) => {
        sessionStorage.setItem('eventCode', id)
        setVisitId(id)

        setLoading(true);
        let params = {
            id: id
        }
        setShowVisitForm(false); // 每次切换，重置表单渲染

        subjectBindState()
        
        api.getFormsById(params).then(res => {
            if (res.code == '0') {
                let filterArr = [];
                filterArr.push(res.data)
                setFormData(filterArr)
                if(res.data.scales.length > 0) {
                    setSelfReportedList([res.data])
                } else {
                    setSelfReportedList([])
                }
                // 如果节点下面只有一个表单时，直接渲染
                let _item = res.data;
                // if (_item && _item.forms && _item.forms.length === 1) {
                if (_item && _item.forms && _item.type === 'SingleForm') {
                    clickForm(_item, _item.forms[0])();
                }


                let currentVisitInfo = JSON.parse(JSON.stringify(res.data))
                delete currentVisitInfo.forms
                sessionStorage.setItem('currentVisitInfo', JSON.stringify(currentVisitInfo));
            }
            setLoading(false);
        })
    }

    //switch表单左侧的border颜色
    const switchFormBorder = (formData: any) => {
        switch (formData.inputState) {
            case 'Complete':
                return <div style={{ backgroundColor: '#6c96f7' }}></div>
            case 'Running':
                return <div style={{ backgroundColor: '#52C41A' }}></div>
            case 'Wait':
                return <div style={{ backgroundColor: '#e6ebf5' }}></div>
            case 'Question':
                return <div style={{ backgroundColor: '#ef8767' }}></div>
            case 'Answer':
                return <div style={{ backgroundColor: '#477291' }}></div>
            default:
                break;
        }
    }

    //处理from中input状态
    const switchFormInputState = (inputState: any) => {
        switch (inputState) {
            case 'Complete':
                return <IconFont type="iconInput_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconluru2"></IconFont>
            case 'Wait':
                return <IconFont type="iconInput_Wait"></IconFont>
            default:
                break;
        }
    }

    //处理from中check状态
    const switchFormCheckState = (checkState: any) => {
        switch (checkState) {
            case 'Complete':
                return <IconFont type="iconCheck_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconxitonghecha"></IconFont>
            case 'Wait':
                return <IconFont type="iconCheck_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconCheck_Question"></IconFont>
            default:
                break;
        }
    }

    //处理from中question状态
    const switchFormQuestionState = (questionState: any) => {
        switch (questionState) {
            case 'Complete':
                return <IconFont type="iconQuestion_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconrengonghecha"></IconFont>
            case 'Wait':
                return <IconFont type="iconQuestion_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconQuestion_Question"></IconFont>
            case 'Answer':
                return <IconFont type="iconQuestion_Answer"></IconFont>
            default:
                break;
        }
    }

    //处理from中Examine状态
    const switchFormExamineState = (examineState: any) => {
        switch (examineState) {
            case 'Complete':
                return <IconFont type="iconExamine_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconshujuhecha"></IconFont>
            case 'Wait':
                return <IconFont type="iconExamine_Wait"></IconFont>
            case 'Question':
                return <IconFont type="iconExamine_Question"></IconFont>
            case 'Answer':
                return <IconFont type="iconExamine_Answer"></IconFont>
            default:
                break;
        }
    }

    //处理from中Freeze状态
    const switchFormFreezeState = (freezeState: any) => {
        switch (freezeState) {
            case 'Complete':
                return <IconFont type="iconFreeze_Complete"></IconFont>
            case 'Running':
                return <IconFont type="icondongjie1"></IconFont>
            case 'Wait':
                return <IconFont type="iconFreeze_Wait"></IconFont>
            default:
                break;
        }
    }
    //处理from中Autograph状态
    const switchFormAutographState = (autographState: any) => {
        switch (autographState) {
            case 'Complete':
                return <IconFont type="iconAutograph_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconqianming1"></IconFont>
            case 'Wait':
                return <IconFont type="iconAutograph_Wait"></IconFont>
            default:
                break;
        }
    }

    //处理from中Lock状态
    const switchFormLockState = (lockState: any) => {
        switch (lockState) {
            case 'Complete':
                return <IconFont type="iconLock_Complete"></IconFont>
            case 'Running':
                return <IconFont type="iconsuoding2"></IconFont>
            case 'Wait':
                return <IconFont type="iconLock_Wait"></IconFont>
            default:
                break;
        }
    }

    //处理ocr录入状态
    const switchFormOcrState = (ocrState: any) => {
        switch (ocrState) {
            case 'Complete':
                return <IconFont type="iconOcr_Complete"></IconFont>
                break;
            case 'Wait':
                return <IconFont type="iconOcr_Wait"></IconFont>
                break;
            case 'Running':
                return <IconFont type="iconxiangji"></IconFont>
                break;
            default:
                break;
        }
    }

    //当点击了访视列表
    const onClickVisit = (item: any) => {
        return (e: any) => {
            const { id } = item

            setVisitId(id);
            setVisit(item)

            //清除选中状态
            if (selectedEle) {
                let ele = document.getElementById(selectedEle);
                if (ele) {
                    ele.style.backgroundColor = '#FFFFFF';
                    ele.style.fontWeight = '400';
                }
            }
            setSelectedEle(e.currentTarget.id);
            e.currentTarget.style.backgroundColor = '#bccef9';
            e.currentTarget.style.fontWeight = '700';

            getFormsById(id, subjectsData);
            //保存操作访视状态
            let currentState = {
                type: 'visit',
                key: id
            }
            sessionStorage.setItem('currentState', JSON.stringify(currentState));
        }
    }

    //审核失败提示
    const onClickAuditRejectTip = () => {
        Dialog.alert({
            header: (
                <div></div>
            ),
            title: '',
            content: (
                <>
                    <div style={{ padding: '15px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <img style={{ width: '40px' }} src={warning} alt="" />
                        </div>
                        <div style={{ color: '#ef8a00', fontWeight: 'bold', fontSize: '15px', textAlign: 'center', marginBottom: '10px' }}>
                            该任务未通过审核
                        </div>
                        <div>请您仔细检查数据填写是否有误，修改后审核人员将对您上传的任务进行重新审核</div>
                        {
                            rejectReasons && rejectReasons.length > 0 &&
                            <div style={{ color: '#000000', fontWeight: 'bold', fontSize: '14px', marginTop: '15px', marginBottom: '10px' }}>
                                未通过原因：
                            </div>
                        }
                        {
                            rejectReasons && rejectReasons.map((item: any) => (
                                <div>
                                    {item}
                                </div>
                            ))
                        }
                    </div>
                </>
            ),
        })
    }

    //当点击了任务按钮
    const onClickTask = (taskType: any) => {
        return (e: any) => {
            //清除选中状态
            if (selectedEle) {
                let ele = document.getElementById(selectedEle);
                if (ele) {
                    ele.style.backgroundColor = '#FFFFFF';
                    ele.style.fontWeight = '400';
                }
            }
            setSelectedEle(e.currentTarget.id);
            if (['Answer', 'ImageAnswer', 'Quest'].includes(taskType)) {
                e.currentTarget.style.backgroundColor = '#fae2a2';
            } else {
                e.currentTarget.style.backgroundColor = '#bccef9';
            }
            e.currentTarget.style.fontWeight = '700';

            //保存操作访视状态
            let currentState = {
                type: 'task',
                key: taskType
            }
            sessionStorage.setItem('currentState', JSON.stringify(currentState));

            setLoading(true);
            api.getVisitsByType({ subjectCode: subjectsData.code, type: taskType }).then(res => {
                if (res.code == '0') {
                    if(taskType === 'Quest') {
                        setFormData([])
                        setSelfReportedList(res.data)
                    } else {
                        setFormData(res.data)
                        setSelfReportedList([])
                    }
                }
                setLoading(false);
            })
        }
    }

    //点击表单
    const clickForm = (item: any, formItem: any) => {
        return () => {
            const _istime = (formData[0]?.state === 'Stop' || formData[0]?.state === 'Pause' || formData[0]?.state === 'Wait')
            // 南宁经治项目特殊处理
            if(subjectsData.projectCode ===  'PROJECT10000618' && formItem.name === '实验室检查' && _istime) {
                Toast.fail('请先登记实际访视日期', 1)
                return
            }

            // 服务客户：鞍石项目-伯瑞替尼项目 
            // 需求：访视2需要在基线访视提交并审核通过日期大于等于30天后，才可填写表单
            // const env = process.env.REACT_APP_ENV;
            // if (((env === 'test' || env === 'development') && subjectsData.projectCode === 'PROJECT10000635') || (env === 'production' && ['PROJECT10000502', 'PROJECT10000503'].includes(subjectsData.projectCode))) {
            //     if (subjectsData.visits?.length > 1) {
            //         let startDate: any = '';
            //         if (subjectsData.basePassTime) {
            //             startDate = moment(subjectsData.basePassTime).startOf('day')
            //         }
            //         // 基线与访视2
            //         const formPass = subjectsData.visits.find((e:any) => e.name == '基线')?.formPass
            //         const isVisit2 = item.name === '访视2'
            //         if (isVisit2 && formPass !== 'Complete') {
            //             return Toast.fail("基线审核通过30天之后，可填写该访视2", 1);
            //         } else if (isVisit2 && formPass == 'Complete' && startDate && new Date().getTime() < new Date(startDate).getTime() + 30 * 24 * 60 * 60 * 1000) {
            //             const date = moment(new Date(startDate).getTime() + 30 * 24 * 60 * 60 * 1000).format("YYYY月MM月DD日")
            //             return Toast.fail((`${date}之后，可填写该访视2`), 1)
            //         }
            //     }
            // }
            // 锁定状态
            if (formItem.lockState && formItem.lockState == 'Complete') {
                sessionStorage.setItem('formLockState', formItem.lockState)
            }

            let filterArr = [];
            for (let i of item.forms) {
                filterArr.push({
                    title: i.name,
                    id: i.id,
                    code: i.code,
                    inputState: i.inputState
                })
            }

            let forms = {
                activeId: formItem.id,
                state: item.state,
                forms: filterArr,
                autoOcr: subjectsData.autoOcr
            };
            localStorage.setItem('localStorage_forms', JSON.stringify(forms));

            // if (item.type === 'SingleForm') {
            //     setShowVisitForm(true);
            // } else {
            //     props.history.push({ pathname: '/visitForm' });
            // }

            // 单表单模式
            if (item.type == 'SingleForm') {

                // crf表单
                if (formItem.type == 'CRF') {
                    registerCrfMicro(formItem)
                } else {
                    sessionStorage.removeItem('crfParams')
                }
                setShowVisitForm(true);

            } else {

                // crf表单
                if (formItem.type == 'CRF') {
                    registerCrfMicro(formItem)
                } else {
                    sessionStorage.removeItem('crfParams')
                }
                props.history.push({ pathname: '/visitForm' });
            }
        }
    }

    // crf表单集成
    const registerCrfMicro = (formItem: any) => {
        const caseCode = sessionStorage.getItem('caseCode');
        const eventCode = sessionStorage.getItem('eventCode');

        let crfParams = {
            crfCode: formItem.code,
            crfVersion: formItem.version,
            recordCode: formItem.id,
            tenantCode: '',

            caseCode,
            eventCode,
            projectCode: '',
            userCode: '',
            headers: {},
        }

        const token = sessionStorage.getItem('token');
        const _itemData = sessionStorage.getItem('toPhotoEditItem');
        if (token) {
            let t = JSON.parse(token);
            crfParams.tenantCode = t.tenantCode
            crfParams.userCode = t.userCode
        }
        if (_itemData) {
            let _i = JSON.parse(_itemData);
            crfParams.projectCode = _i.projectCode
        }

        sessionStorage.setItem('crfParams', JSON.stringify(crfParams))
    }

    //添加表单
    const addFormBtn = (item: any) => {
        return () => {

        }
    }

    //当点击实际访视时间修改按钮
    const onClickVisitDateModify = (form: any) => {
        return () => {
            if (form.visitDate) {
                setVisitDate(new Date(form.visitDate))
            }
            else {
                setVisitDate(new Date())
            }
            setVisitDateModalShow(true);
        }
    }

    //当点击预约访视时间修改按钮时
    const onClickAppointmentDateDateModify = (form: any) => {
        return () => {
            if (form.appointmentDate) {
                setAppointmentDate(new Date(form.appointmentDate))
            }
            else {
                setAppointmentDate(new Date())
            }
            setAppointmentDateModalShow(true);
        }
    }

    //获取剩余访视次数
    const getRemainingVisits = () => {
        const index = subjectsData.visits.findIndex((item:any) => item.id === visitId)
        const surplusVistisArr = subjectsData.visits.slice(index + 1, index + 4)
        setRemainingVisits(surplusVistisArr.length)
        
    }

    const handleConfirm = (dateVal: any, changeOtherVisitDate: any) => {
        let params = {
            planDate: moment(dateVal).format('YYYY-MM-DD'),
            visitId,
            subjectCode: subjectsData.code,
            changeOtherVisitDate
        }
        setLoading(true);

        api.modifyPlanDate(params).then(res => {
            if (res.code == '0') {
                Toast.success('修改成功！', 1)
                //更新数据
                getFormsById(visitId);
                initData();
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('修改失败！', 1)
                }
            }
            setLoading(false);
        })
    }

    //当实际访视时间修改时
    const onVisitDateModify = (form: any) => {
     
        let params = {
            visitDate: moment(visitDate).format('YYYY-MM-DD'),
            visitId: form.id
        }
        setLoading(true);
        api.modifyVisitDate(params).then(res => {
            if (res.code == '0') {
                Toast.success('修改成功！', 1)
                setVisitDateModalShow(false);
                //更新数据
                getFormsById(form.id);
                initData();
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('修改失败！', 1)
                }
            }
            setLoading(false);

        })
    }


    //当预约访视时间修改时
    const onAppointmentDateModify = (form: any) => {
        let params = {
            appointmentDate: moment(appointmentDate).format('YYYY-MM-DD'),
            visitId: form.id
        }
        setLoading(true);
        api.modifyAppointmentDate(params).then(res => {
            if (res.code == '0') {
                Toast.success('修改成功！', 1)
                setAppointmentDateModalShow(false);
                //更新数据
                getFormsById(form.id);
                initData();
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('修改失败！', 1)
                }
            }
            setLoading(false);
        })
    }

    //当点击添加备注按钮
    const onClickAddRemark = () => {
        setLoading(true);
        let params = {
            type: 'SubjectRemarkType'
        }
        api.getRemarkType(params).then(res => {
            if (res.code == '0') {
                if (res.data && res.data.length > 0) {
                    let filterArr = [];
                    for (let item of res.data) {
                        filterArr.push(
                            {
                                label: item.name,
                                value: item.code
                            }
                        )
                    }
                    setRemarkTypeList(filterArr);
                }
            }
            setLoading(false);
        })
        let isWarningList = [
            {
                label: '警示',
                value: 1,
            },
            {
                label: '非警示',
                value: 0,
            }
        ]
        setIsWarningList(isWarningList);
        setRemarkModalShow(true);
    }

    //当提交备注
    const onRemark = () => {
        if (remarkIsWarning && remarkValue && remarkValue.trim() && currentRemarkType && currentRemarkType.length > 0) {
            let params = {
                subjectCode: subjectsData.code,
                isWarning: remarkIsWarning[0],
                remark: remarkValue,
                remarkType: currentRemarkType[0]
            }
            setLoading(true);
            api.addRemark(params).then(res => {
                if (res.code == '0') {
                    initData();
                    Toast.success('添加成功！', 1)
                    setCurrentRemarkType(null);
                    setRemarkValue(null);
                    setRemarkIsWarning(null);
                    setRemarkModalShow(false);
                }
                else {
                    if (res.message) {
                        Toast.success(res.message, 1);
                    }
                    else {
                        Toast.success('添加失败！', 1);
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请填写完整后再试！', 1)
        }
    }


    //审核失败质疑，重新提交
    const reSubmit = () => {
        if (VisitFormRef.current) {
            VisitFormRef.current.dealVideo()
        }
        api.toAuditResubmit(subjectsData.code).then((res: any) => {
            if (res.code == 0) {
                Toast.success('审核重新提交成功', 1);
                setShowReSubmitBtn(false);
                initData();
            } else {
                Toast.fail(res.message || '提交失败', 1);
            }
        })
    }

    // 签署
    const onSignLaborAgreement = () => {
        props.history.push(`/laborAgreement?code=${subjectsData.code}&signState=${subjectsData.signState}`)
    }



    /**
     * 显示操作按钮
     */
    const showAcitonBtns = () => {

        let reasons = ''
        if (rejectReasons.length > 0) {
            reasons = rejectReasons.join(',')
        }

        if (subjectsData) {
            if (subjectsData.singleSignState == '0') {
                return (
                    <div className={styles.singlesign_btn_wrap} >
                        <div className={styles.singlesign_btn_wrap} >
                            {
                              subjectsData.roleCode !== 'ReadOnly' && (
                                <>
                                  <div className={styles.sign_btn} onClick={downLoadCase}>
                                      <span className={styles.download_icon}></span>
                                      下载病例
                                  </div>
                                  <div className={styles.sign_btn} onClick={() => setShowUploadModal(true)}>
                                      <span className={styles.upload_icon}></span>
                                      签名回传
                                  </div>
                                </>
                              )
                            }
                            <div className={styles.sign_btn_disable} >
                                <span className={styles.view_icon_disable}></span>
                                签名查看
                            </div>
                        </div>
                    </div>
                )

            } else if (subjectsData.singleSignState == '1' || subjectsData.singleSignState == '2' || subjectsData.singleSignState == '3') {
                return (
                    <div className={styles.singlesign_btn_wrap} >
                        { 
                          subjectsData.roleCode !== 'ReadOnly' && (
                            <>
                              <div className={styles.sign_btn} onClick={downLoadCase}>
                                  <span className={styles.download_icon}></span>
                                  下载病例
                              </div>
                              {
                                subjectsData.singleSignState == '3' && (
                                  <div className={styles.sign_btn} onClick={() => setShowUploadModal(true)}>
                                    <span className={styles.upload_icon}></span>
                                    签名回传
                                  </div>
                                )
                              }
                            </>
                          )
                        }
                        <div className={styles.sign_btn_blue} onClick={getSign}>
                            <span className={styles.view_icon}></span>
                            签名查看
                        </div>
                    </div>
                )

            } if (subjectsData.signState == 'Wait') {
                return (
                    <div className={styles.sign_btn_wrap}>
                        <div className={styles.sign_btn} onClick={onSignLaborAgreement}>
                            未签署
                        </div>
                    </div>
                )
            } else if (subjectsData.signState == 'Pass' && reasons == '签名不合格') {
                return (
                    <div className={styles.sign_btn_wrap}>
                        <div className={styles.sign_btn} onClick={onSignLaborAgreement}>
                            <span className={styles.rest_sign}></span>
                            重新签署
                        </div>
                    </div>
                )
            }

            else if (subjectsData.auditState === "Fail" && showReSubmitBtn && !reasons.includes('签名不合格')) {
                return (
                    <div>
                        <div className={styles.btn_bottom} onClick={reSubmit}>
                            重新提交审核
                        </div>
                    </div>
                )
            }
            else if (subjectsData.state == 'Active' && subjectsData.auditButtonStatus == "1") {
                return (
                    <div>
                        <div className={styles.btn_bottom} onClick={submitAudit}>
                            立即提交审核
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <React.Fragment>
                        {
                            (subjectsData.auditState === "Fail" && showReSubmitBtn) &&
                            <div className={styles.btn_bottom} onClick={reSubmit}>重新提交审核</div>
                        }
                        {
                            subjectsData.signState == 'Pass' && reasons.includes('签名不合格') &&
                            <div className={styles.sign_btn_wrap}>
                                <div className={styles.sign_btn} onClick={onSignLaborAgreement}>
                                    <span className={styles.rest_sign}></span>
                                    {subjectsData.signState == 'Pass' ? '重新签署' : '未签署'}
                                </div>
                            </div>
                        }
                    </React.Fragment>
                )
            }
        }
    }


    const submitAudit = () => {
        let params = {
            code: subjectsData.code
        }

        api.submitAudit(params).then((res: any) => {
            if (res.code == 0) {
                Toast.success('审核提交成功', 1);
                initData();
            } else {
                Toast.fail(res.message || '提交失败', 1);
            }
        })

    }

    // 修改计划访视时间
    const onModifyPlanDate = (item: any) => {
        let regex = /\d{4}-\d{2}-\d{2}/
        let matchDate = item.planDate ? item.planDate.match(regex) : null;
        // let matchDate = item?.planDate.match(regex)
        return (e: any) => {
            const { roleCode } = storageX().user()
            if (projectRoleCode == 'ReadOnly' || roleCode === 'EDC_READ' || item.state === 'Stop' || item.state === 'Wait') {
                // setCurrentPlanDate(new Date())
                setCurrentPlanDate(matchDate ? new Date(matchDate[0]) : null)
                setPlanModal(true);
            } else{
                return
            }
        } 
    }

    // 修改实际访视时间
    const onModifyVisitDate = (item: any) => {
        return (e: any) => {
            const { roleCode } = storageX().user()
            if (projectRoleCode == 'ReadOnly' || roleCode === 'EDC_READ') {
                return
            }
            if (item.formPass === "Complete" && item.state === 'Complete') {
                return
            }
            if (['Running', 'Complete'].includes(item.state)) {
                setVisitId(item.id)
                setCurrentVisitDate(new Date(item.visitDate))
                setVisitModal(true);
                return
            }
            // if (projectRoleCode == 'ReadOnly' || currentRole === 'EDC_READ' || item.state==="Running") {
            //     setCurrentVisitDate(new Date(item.visitDate))
            //     setVisitModal(true);
            // } else{
            //     return
            // }
        }
    }

    // 
    const renderVistTimeColor = (item: any) => {
        const { roleCode } = storageX().user()
        if (item.formPass === "Complete" && item.state === 'Complete') {
            return {
                color: '',
                backgroundColor: ''
            }
        }

        if (projectRoleCode == 'ReadOnly' || roleCode === 'EDC_READ') {
            return {
                color: '',
                backgroundColor: ''
            }
        }

        if (['Running', 'Complete'].includes(item.state)) {
            return {
                color: '#6287ec',
                backgroundColor: '#e3eefb'
            }
        }
        return {
            color: '',
            backgroundColor: ''
        }
    }


    const getSign = () => {
        let params: any = {
            subjectCode: subjectsData.code
        }
        api.getSingleSign(params).then((res: any) => {
            if (res.code == 0) {
                if (res.data) {
                    let fileType = res.data.includes('pdf') ? 'pdf' : 'image'
                    setCaseFileType(fileType)
                    setCaseImageUrl(res.data)
                    setShowCaseImage(true)
                } else {
                    Toast.info('暂无签名文件', 1)
                }
            } else {
                Toast.info('获取签名文件失败')
            }
        })
    }



    /**
     * 上传
     */
    const onUpload = async(id: any): Promise<object | undefined> => {
        let input: any = document.getElementById(id);
        let _file = input.files[0]
        setFileName(_file.name)

        const pieces = await makeUploadOptions()
        
        if (!pieces) {
            return;
        }

        const [prefix, options] = pieces;

        let client = new OSS(options);

        return new Promise((resolve, reject) => {
            const file = _file;
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            let start = Date.now();
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                const pathname = makeUploadName(prefix, file)
                
                if (!pathname) {
                    return
                }
                if (id == 'takeFile' && suffix !== '.pdf') {
                    Toast.fail("请上传pdf文件", 1);
                    return false
                }
                // oss上传
                client.put(pathname, file,).then((res: any) => {
                    let url = res.url;
                    resolve({ url: url });
                    Toast.success('上传成功', 1)
                    setSignUrl(url)
                }).catch((err: any) => {
                    Toast.fail('上传失败，请重新上传！', 1)
                })
            }
        });
    };

    // 关闭弹窗
    const handleCloseModal = ()=>{
        setSignUrl('')
        setFileName('')
        setShowUploadModal(false)
    }

    //确定签名回传
    const handleSign = () => {
        if(!signUrl){
            Toast.fail('请上传签名回传文件', 1)
            return  
        }
        let params: any = {
            subjectCode: subjectsData.code,
            signUrls: signUrl
        }

        api.singleAudit(params).then((res: any) => {
            if (res.code == 0) {
                Toast.info('回传成功', 1)
                handleCloseModal()
                getData()
            }
        })
    }



    //pdf加载获取页码
    const onDocumentLoadSuccess = (numPages :any) => {
        setNumPages(numPages);
    }

    // //pdf获取所有页数
    // const getPrintRender = () => {
    //     return new Array(numPages || []).fill(0).map((ele, i) => {
    //         return (
    //             <Page key={i + 1} pageNumber={i + 1} />
    //         )
    //     })
    // }

    //显示邮箱modal
    const downLoadCase = () => {
        api.downloadCases(subjectsData.code).then(({ code, message, data })=> {
            if(code == '0') {
                setCasePreviewUrl(data[0])
            } else {
                Toast.fail(message, 2)
            }
        })
        setShowEmailModal(true)
    }

    //改变邮箱地址
    const changeEmail = (event: any) => {
        setEmailAddress(event.target.value);
    }

    //关闭邮箱地址模态框
    const closeEmail = () => {
        setShowEmailModal(false)
    }

    //发送邮件
    const handleSendEmail = () => {
        let emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (emailReg.test(emailAddress) == false) {
            Toast.info('邮箱格式不对，请重新输入！', 1)
            return false;
        }

        let params = {
            email: emailAddress,
            subjectCode: subjectsData.code
        }
        api.sendCaseEmail(params).then(res => {
            if (res.code == '0') {
                Toast.success('发送成功')
                closeEmail()
            }
        })
    }

    //获取病例发送邮箱
    const getCaseEmail = () => {
        api.getCaseEmail().then((res: any) => {
            if (res.code == '0' && res.data) {
                setEmailAddress(res.data)
            }
        })
    }

    const subjectBindState = async () => {
        try {
         api.getSubjectBindState(subjectCode).then(res=>{
            setInfo(res.data ?? { bindState: -1 });
         })
    
        } catch (error) {
          return Promise.reject(error);
        }
      };
    
    const handleDownloadCase = ()=> {
        if(typeof window.wx.miniProgram.navigateTo === 'function') {
            window.wx.miniProgram.navigateTo({
                url: `/pages/download/download?url=${casePreviewUrl}`,
                success() {
                    closeEmail()
                },
                fail() {
                    Modal.alert('提示', '下载文件失败')
                }
            })
        } else {
            // utils.downloadFile(casePreviewUrl)
            Modal.alert('提示', '请在小程序打开')
        }
    }

    const handCopyURL = async ()=> {
        try {
            navigator.clipboard.writeText(casePreviewUrl)
            Toast.success('链接已复制')
        } catch(e) {
            Toast.fail('复制链接失败')
        }
    }

    // 显示拒绝原因
    const showRejectReson = () => {

        if (subjectsData.singleSignRejectState) {
            console.log(subjectsData.singleSignRejectState);
            let signRejectState = subjectsData.singleSignRejectState.split(',')
            let _rejectReasonList: any = []
            signRejectState.forEach((v: any) => {
                if (v == '1') {
                    _rejectReasonList.push('回传数据不完整')
                } else if (v == '2') {
                    _rejectReasonList.push('回传数据不匹配')
                } else if (v == '3') {
                    _rejectReasonList.push('回传数据不清晰')
                } else if (v == '4') {
                    if (subjectsData.singleSignRejectReason) {
                        _rejectReasonList.push('其他(' + subjectsData.singleSignRejectReason + ')')
                    } else {
                        _rejectReasonList.push('其他')
                    }
                }
            })
            console.log(_rejectReasonList);
            setRejectReasonList(_rejectReasonList)

        }
        setRejectReasonModal(true)
    }

    // 隐藏实际访视日期
    const hiddenRealVisitDate = (item: any)=> {
        // 优先
        if (configuration.hiddenVisitDate) {
            return true
        }
        if (subjectsData.auditState == 'Pass') {
            return false
        }
        if (item.lockState == 'Complete') {
            return true
        }
        if (subjectsData.isLock == '1') {
            return true
        }
        if (!(subjectsData.visits && subjectsData.visits.length > 1)) {
            return true
        }
        return !switchVisitTime(item)
    }

    const reloadSubjectData = async()=> {
        const { code, data } = await api.getSubjectdDetail({ id: props.match.params.id })
        if(code == "0") {
            setSubjectsData(data)
        }
    }

    return (
        <div className={styles.subjectsDetail_content}>
            {
                projectType === 'CASESOLICIT' && !isOriginPage &&
                <CaseCollect subjectsData={subjectsData} formData={formData} rejectReasons={rejectReasons} clickForm={clickForm} initData={initData} />
            }
            {
                projectType === 'LISTEDSTYDY' && !isOriginPage &&
                <RwdDetail subjectsData={subjectsData} formData={formData} rejectReasons={rejectReasons} clickForm={clickForm} initData={initData} />
            }
            {
                ((projectType !== 'CASESOLICIT' && projectType !== 'LISTEDSTYDY') || isOriginPage) &&
                <>
                    {
                        (isOriginPage || projectType !== 'VIDEOSOLICIT' && projectType !== 'QUESTIONSURVEY') &&
                        <div className={styles.header_content}>
                            <div 
                            className={styles.portrait} 
                            style={nameSearch === 1 ? { marginBottom: '35px'} : {}}>
                                <img src={defaultAvatar} alt="defaultAvatar" />
                            </div>
                            <div className={styles.info}>
                                <div className={styles.info_top}>

                                    {/* {subjectsData.subjectName ? (
                                        <div className={styles.projectId}>
                                            <div className={styles.subName}>{subjectsData.subjectName}</div>
                                            <span className={styles.subCode}>（&nbsp;{subjectsData.code}&nbsp;）</span>
                                        </div>
                                    ) : (
                                        <span className={styles.projectId}>{subjectsData.code}</span>
                                    )} */}
                                    <div className={styles.projectId}>
                                        {nameSearch === 1 
                                            ? subjectsData.subjectName ? subjectsData.subjectName : '暂无' 
                                            : subjectsData.code}
                                    </div>
                                    <span className={styles.userName}>
                                        {subjectsData.createUser}
                                    </span>
                                    {/*<span className={styles.addBtn} onClick={onClickAddRemark}>*/}
                                    {/*    <IconFont type="iconAdd"></IconFont>添加备注*/}
                                    {/*</span>*/}
                                </div>
                                {nameSearch === 1 && (
                                    <div className={styles.info_projectName}>
                                        {subjectsData.code}
                                    </div>
                                )}
                                <div className={styles.info_projectName}>
                                    <span className={styles.info_projectName__title}>{subjectsData.projectName}</span>
                                  
                                </div>
                                {/* subjectsData.code 加载显示优化*/}
                                {(subjectsData.code &&  subjectScaleReportState === 1)&& <SubjectBind editModel={ subjectsData.editModel }  mobile={subjectsData.mobile} subjectName={subjectsData.subjectName} refresh={getFormsById} resumeVisitId={visitId}  isShowBind={(subjectsData.editModel === 1 && subjectsData?.informed == 1  && info.bindState !== 1)? false : true} initData={initData}/>  }
                                {/* 分组 */}
                                <div className={styles.info_projectName}>
                                    {subjectsData.groupName}
                                </div>
                                {/* 状态 */}
                                 
                                {
                                    !subjectsData.auditState &&
                                    <div className={styles.info_state}>
                                        {/* {
                                            subjectsData.informed === 1 && subjectsData.editModel === 1 && (
                                                <Preview url={subjectsData.agreementUrl} margin="0 5px 0 0"/>
                                            )
                                            
                                        } */}
                                         {/* 君实签署协议 */}
                                         { 
                                  
                                            subjectsData.editModel === 1  &&  (['EDC_CRC', 'DCT_CRC'].includes(mToken.roleCode) && projectRoleCode !== 'ReadOnly'  ) && subjectsData.informed !== 2 && (
                                    
                                            <SignAgreementLink onReload={reloadSubjectData} subjectsData={subjectsData}/>
                                        
                                        )}
                                        {
                                            subjectsData.state === 'Withdraw' && (
                                                <span style={{ color: '#b50a0a', marginLeft: 5 }}><IconFont type="iconWait"/>撤回知情同意</span>
                                            )
                                        }
                                        {subjectsData.state == 'Init' ? <React.Fragment>
                                            <span style={{ color: '#52C41A', marginLeft: 5 }}><IconFont type="iconWait"></IconFont>待入组</span>
                                        </React.Fragment> : null}
                                        {subjectsData.state == 'Active' ? <React.Fragment>
                                            <span style={{ color: '#52C41A', marginLeft: 5 }}><IconFont type="iconjinhangzhongxiangmu"></IconFont>进行中</span>
                                        </React.Fragment> : null}
                                      
                                        {subjectsData.state == 'Finish' && subjectsData.signState == 'Wait' ? <React.Fragment>
                                            <div style={{ color: '#C4AE01', display: 'flex', marginLeft: 5 }}>
                                                <span className={styles.no_sign}></span>
                                                <span>未签署</span>
                                            </div>
                                        </React.Fragment> : subjectsData.state == 'Finish' ? <React.Fragment>
                                            <span style={{ color: '#6c96f7', marginLeft: 5 }}><IconFont type="iconvisitComplete"></IconFont>已完成</span>
                                        </React.Fragment> : null}
                                    </div>
                                }

                                
                                <div className={styles.audit_state_content}>
                                    {/* 审核状态 */}
                                    {
                                        subjectsData.auditState &&
                                        <div className={`${styles.audit_state} ${styles.audit_state_item}`}>
                                              {/* 君实签署协议 */}
                                             { 
                                  
                                                subjectsData.editModel === 1  &&  (['EDC_CRC', 'DCT_CRC'].includes(mToken.roleCode) && projectRoleCode !== 'ReadOnly'  ) && subjectsData.informed !== 2 && (
                                        
                                                <SignAgreementLink onReload={reloadSubjectData} subjectsData={subjectsData}/>
                                            
                                            )}
                                            {
                                                subjectsData.auditState === 'Wait' &&
                                                <div className={styles.audit_remain} style={{marginLeft: 5}}>
                                                    <img src={icon_audit_remain} alt="" />
                                                    <span>待审核</span>
                                                </div>
                                            }
                                            {
                                                subjectsData.auditState === 'Pass' && (
                                                    <div className={styles.audit_pass} style={{marginLeft: 5}}>
                                                        <img src={icon_audit_remain} alt="" />
                                                        <span>审核通过</span>
                                                    </div>
                                                )
                                            }
                                            {
                                                subjectsData.auditState === 'Fail' &&
                                                <div className={styles.audit_no_pass} style={{marginLeft: 5}}>
                                                    <img src={icon_audit_no_pass} alt="" />
                                                    <span>审核未通过</span>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {/* 签名状态 */}
                                    {subjectsData.singleSignState != 'null' && <div className={`${styles.audit_state} ${styles.audit_state_item}`}>
                                        {
                                            subjectsData.singleSignState == '0' &&
                                            <div className={styles.noStart}>
                                                <img src={icon_sign_already} alt="" />
                                                <span>待签名</span>
                                            </div>
                                        }
                                        {
                                            subjectsData.singleSignState == '1' &&
                                            <div className={styles.running}>
                                                <img src={icon_sign_remain1} alt="" />
                                                <span>已签名</span>
                                            </div>
                                        }
                                        {
                                            subjectsData.singleSignState == '2' &&
                                            <div className={styles.running}>
                                                <img src={icon_sign_remain} alt="" />
                                                <span>签名已审</span>
                                            </div>
                                        }
                                        {
                                            subjectsData.singleSignState == '3' &&
                                            <div className={styles.notPass}>
                                                <img src={icon_sign_no_pass} alt="" />
                                                <span>签名不合格</span>
                                            </div>
                                        }
                                    </div>}

                                </div>
                                {/* 备注 */}
                                <div className={styles.note_content}>
                                    <div className={styles.remarks}>
                                        {
                                            subjectsData.remarks && subjectsData.remarks.map((item: any, index: any) => {
                                                return (
                                                    <span key={index} style={{ color: item.isWarning ? '#EF8767' : '#9A9FAB', border: item.isWarning ? '1px solid #EF8767' : '1px solid #9A9FAB' }}>{item.remark}</span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* {subjectsData.editModel === 1 && subjectsData.roleCode !== 'ReadOnly' && <button onClick={ ()=> setTransoutModalVisible(true) } className={styles.transout_btn} type="button">{targetName}转移</button>} */}
                        </div>
                    }
                    {
                        // projectType !== 'VIDEOSOLICIT' &&
                        // projectType !== 'QUESTIONSURVEY' && projectType !== 'VIDEOSOLICIT' &&
                        <div className={styles.tasks_content}>
                            <div className={styles.visit_tasks}>
                                {
                                    subjectsData.tasks && subjectsData.tasks.map((item: any, index: any) => {
                                        {
                                            if (item.type === 'Check') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconCheck_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconCheck_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconxitonghecha"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Question':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #EF8767' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconCheck_Question"></IconFont>
                                                                <span style={{ color: '#EF8767' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (item.type === 'Input') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconInput_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconInput_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconluru2"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (item.type === 'Question') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconQuestion_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconQuestion_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconrengonghecha"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Question':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #EF8767' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconQuestion_Question"></IconFont>
                                                                <span style={{ color: '#EF8767' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Answer':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #eab426' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconQuestion_Answer"></IconFont>
                                                                <span style={{ color: '#eab426' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (item.type === 'Examine') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconExamine_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconExamine_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconshujuhecha"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Question':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #EF8767' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconExamine_Question"></IconFont>
                                                                <span style={{ color: '#EF8767' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Answer':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #477291' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconExamine_Answer"></IconFont>
                                                                <span style={{ color: '#477291' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (item.type === 'Freeze') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconFreeze_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconFreeze_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="icondongjie1"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (item.type === 'Autograph') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconAutograph_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconAutograph_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconqianming1"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (item.type === 'Lock') {
                                                switch (item.state) {
                                                    case 'Complete':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #6c96f7' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconLock_Complete"></IconFont>
                                                                <span style={{ color: '#6c96f7' }}>
                                                                    {item.message}
                                                                </span>
                                                            </span>
                                                        )
                                                    case 'Wait':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #E6EBF5' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconLock_Wait"></IconFont>
                                                                <span style={{ color: '#E6EBF5' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconsuoding2"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            }
                                            else if (['Answer', 'ImageAnswer', 'Quest'].includes(item.type)) {
                                                switch (item.state) {
                                                    case 'Question':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #f7b51e' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <span className={styles.answer}>!</span>
                                                                <span style={{ color: '#f7b51e', display: 'inline-block' }}>
                                                                    {item.message}
                                                                </span>
                                                            </span>
                                                        )
                                                    case 'Running':
                                                        return (
                                                            <span key={index} style={{ border: '1px dashed #52C41A' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={onClickTask(item.type)}>
                                                                <IconFont type="iconsuoding2"></IconFont>
                                                                <span style={{ color: '#52C41A' }}>{item.message}</span>
                                                            </span>
                                                        )
                                                    default:
                                                        break;
                                                }
                                            } else if (item.type === 'AuidtFail') {
                                                return (
                                                    <span key={index} style={{ border: '1px dashed #f7b51e' }} className={styles.taskItem} id={`${item.type}_${index}`} onClick={() => { onClickAuditRejectTip() }}>
                                                        <span className={styles.answer}>!</span>
                                                        <span style={{ color: '#f7b51e', display: 'inline-block' }}>
                                                            {item.message}点击查看详情
                                                        </span>
                                                    </span>
                                                )
                                            } else if (subjectsData.singleSignState == '3') {
                                                return (
                                                    <span key={index} style={{ border: '1px dashed #EF822B' }} className={styles.taskItem} onClick={showRejectReson} >
                                                        <img style={{ width: '12px', height: '13px', margin: '0px 3px' }} src={icon_sign_no_pass} alt="" />
                                                        <span style={{ color: '#EF822B' }}>您有1条签名不合格任务需处理！点击查看详情</span>
                                                    </span>
                                                )
                                            }
                                        }
                                    })
                                }
                            </div>
                        </div>
                    }
                    {
                        subjectsData.visits && subjectsData.visits.length > 1 &&
                        <>
                            <div className={styles.visit_content}>
                                {
                                    subjectsData.visits && subjectsData.visits.map((item: any, index: any) => {
                                        return (
                                            <span key={index} className={styles.visit} id={item.id} onClick={onClickVisit(item)}>
                                                <div className={styles.visitName}>
                                                    {item.name}
                                                </div>
                                                {
                                                    !configuration.hiddenVisitDate && (
                                                        <div className={styles.time}>
                                                            {switchVisitTime(item)}
                                                        </div>
                                                    )

                                                }
                                                

                                                <div className={styles.state}>
                                                    {
                                                        switchVisitState(item)
                                                    }
                                                </div>
                                            </span>
                                        )
                                    })
                                }
                            </div>
                            {/* 进度 */}
                            <div className={styles.progress}>
                                {
                                    subjectsData.visits && subjectsData.visits.map((item: any, index: any) => {
                                        {
                                            switch (item.state) {
                                                case 'Complete':
                                                    return <span key={index} style={{ backgroundColor: '#6c96f7' }}></span>
                                                case 'Running':
                                                    return <span key={index} style={{ backgroundColor: '#52C41A' }}></span>
                                                case 'Lose':
                                                    return <span key={index} style={{ backgroundColor: '#fa413b' }}></span>
                                                case 'Wait':
                                                    return <span key={index} style={{ backgroundColor: '#e6ebf5' }}></span>
                                                default:
                                                    break;
                                            }
                                        }
                                    })
                                }
                            </div>

                        </>
                    }
                    {/* 表单 */}
                    {
                        formData && formData.length > 0 && formData.map((item: any, index: any) => {
                            return (
                                <React.Fragment key={index}>
                                    <div className={styles.visit_Detail}>
                                        {
                                            // 没有患者信息时不显示节点
                                            projectType !== 'VIDEOSOLICIT' && projectType !== 'QUESTIONSURVEY' && item.forms.length > 0 &&
                                            <div className={styles.visit_top}>
                                                <div className={styles.visit_name}>{item.name}</div>
                                            </div>
                                        }
                                        {
                                            // 访视日程
                                            <div className={styles.visit_schedule}>
                                                <div className={styles.visit_tag}>
                                                    访视日程
                                                </div>
                                                <div className={styles.visit_container}>
                                                    {/* 计划访视日 */}
                                                    <>
                                                   {item.type !== 'InclusionCriteria' ? <div 
                                                        className={styles.visit_plan}
                                                        onClick={onModifyPlanDate(item)}
                                                        
                                                   >
                                                        <div className={styles.visit_icon}>
                                                            <UnorderedListOutline fontSize={18} color='#6287ec' />&nbsp;
                                                            计划访视日
                                                        </div>
                                                        <div className={styles.plan_time} style={{ color: item.state === 'Wait' ? '#6287ec' : '#8e8e8e', backgroundColor: item.state === 'Wait' ? '#e3eefb' : '#f2f2f2'}}>{
                                                            item.planDate ? item.planDate : '暂无'
                                                        }</div>
                                                    </div> : null}
                                                    </>
                                                    {/* 实际访视日 */}
                                                    {(projectRoleCode != "ReadOnly" && mToken.roleCode != 'EDC_READ') && <div
                                                        className={styles.visit_Date}
                                                        style={{marginLeft: '10px'}}
                                                        onClick={onModifyVisitDate(item)}
                                                        hidden={hiddenRealVisitDate(item)}
                                                    >
                                                        <HistoryOutlined style={{ color: '#6287ec', fontSize: '16px' }} rev={undefined} />&nbsp;
                                                        实际访视日
                                                        {/* <div className={styles.visit_time} style={{ color: '#6287ec', backgroundColor: '#e3eefb'}}>{item.visitDate ? item.visitDate : '未开始'}</div> */}
                                                        {/* <div className={styles.visit_time} style={{ color: item.state === 'Running' ? '#6287ec' : '', backgroundColor: item.state === 'Running' ? '#e3eefb' : '' }}>{item.visitDate ? item.visitDate : '未开始'}</div> */}
                                                        {
                                                            <div className={styles.visit_time} style={renderVistTimeColor(item)}>{item.visitDate ? item.visitDate : '未开始'}</div>
                                                        }
                                                    </div>}
                                                </div>
                                            </div>
                                        }
                                        {
                                            projectType === 'QUESTIONSURVEY' && !isOriginPage &&
                                            <div className={styles.visit_top_question_survey}>
                                                <div className={styles.visit_name}>
                                                    {
                                                        item.name
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {
                                            //  计划访视和临时访视（无状态）时才显示预约模块
                                            (formData && formData.length == 1 && (formData[0].type === 'PlanVisit' || formData[0].type === 'StatelessVisit')) ?
                                                <div className={styles.detail}>
                                                    <div className={styles.detail_content}>
                                                        <div className={styles.visit_time}>
                                                            <div className={styles.visit_time_title}>
                                                                <span>计划访视时间</span>
                                                            </div>
                                                            <div className={styles.time}>
                                                                {
                                                                    item.planDate ? item.planDate : '暂无'
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* 预约访视时间 */}
                                                        {
                                                            item.state !== 'Wait' ? <div className={styles.visit_time}>
                                                                <div className={styles.visit_time_title}>
                                                                    <span>预约访视时间</span>
                                                                </div>
                                                                <div className={styles.time}>
                                                                    {
                                                                        item.appointmentDate ? item.appointmentDate : '未预约'
                                                                    }
                                                                </div>
                                                            </div> : <div className={styles.visit_time} onClick={onClickAppointmentDateDateModify(item)}>
                                                                <div className={styles.visit_time_title}>
                                                                    <span>预约访视时间</span>
                                                                </div>

                                                                <div className={styles.time}>
                                                                    {
                                                                        item.appointmentDate ? item.appointmentDate : '未预约'
                                                                    }
                                                                    <IconFont type="iconModify"></IconFont>
                                                                </div>
                                                            </div>
                                                        }
                                                        {/* 设置预约访视时间弹框 */}
                                                        <Modal
                                                            visible={appointmentDateModalShow}
                                                            transparent
                                                            maskClosable={false}
                                                            onClose={() => { setAppointmentDateModalShow(false) }}
                                                            title="设置预约访视时间"
                                                            footer={[{ text: '取消', onPress: () => { setAppointmentDateModalShow(false); } }, { text: '确认', onPress: () => { onAppointmentDateModify(item) } }]}
                                                        >
                                                            <DatePickerView
                                                                mode="date"
                                                                value={appointmentDate}
                                                                onChange={(value) => { setAppointmentDate(value) }}
                                                            />
                                                        </Modal>

                                                        {/* 实际访视时间 */}
                                                        {
                                                            item.state === 'Complete' ? <div className={styles.visit_time}>
                                                                <div className={styles.visit_time_title}>
                                                                    <span>实际访视时间</span>
                                                                </div>
                                                                <div className={styles.time}>
                                                                    {
                                                                        item.visitDate ? item.visitDate : '未设置'
                                                                    }
                                                                </div>
                                                            </div> : <div className={styles.visit_time} onClick={onClickVisitDateModify(item)}>
                                                                <div className={styles.visit_time_title}>
                                                                    <span>实际访视时间</span>
                                                                </div>
                                                                <div className={styles.time}>
                                                                    {
                                                                        item.visitDate ? item.visitDate : '设置'
                                                                    }
                                                                    <IconFont type="iconModify"></IconFont>
                                                                </div>
                                                            </div>
                                                        }
                                                        {/* 设置实际访视时间弹框 */}
                                                        <Modal
                                                            visible={visitDateModalShow}
                                                            transparent
                                                            maskClosable={false}
                                                            onClose={() => { setVisitDateModalShow(false) }}
                                                            title="设置实际访视时间"
                                                            footer={[{ text: '取消', onPress: () => { setVisitDateModalShow(false); } }, { text: '确认', onPress: () => { onVisitDateModify(item) } }]}
                                                        >
                                                            <DatePickerView
                                                                mode="date"
                                                                value={visitDate}
                                                                onChange={(value) => { setVisitDate(value) }}
                                                            />
                                                        </Modal>
                                                        <>
                                                        {/* 计划访视时间 */}
                                                        {/* <Modal
                                                            visible={planDateModalShow}
                                                            transparent
                                                            maskClosable={false}
                                                            onClose={() => { setPlanDateModalShow(false) }}
                                                            title="设置计划访视时间"
                                                            footer={[{ text: '取消', onPress: () => { setPlanDateModalShow(false); } }, { text: '确认', onPress: () => { onPlanDateModify(item) } }]}
                                                        >
                                                            <DatePickerView
                                                                mode="date"
                                                                // 类似计算属性return出来
                                                                // disabledDate={this.disabledDate}
                                                                // 修改projectRoleCode || sDetailDtata对应变量
                                                                // disabled={(projectRoleCode == 'ReadOnly' || currentRole === 'EDC_READ' || sDetailDtata.state === 'Stop' || sDetailDtata.state === 'Pause' || this.state.visibleFormData[0]?.lockState === 'Complete')}
                                                                
                                                                value={item.planDate}
                                                                onChange={(value) => { setPlanDate(value) }}
                                                            />
                                                        </Modal> */}
                                                        </>
                                                    </div>
                                                    <div className={styles.visit_label}>
                                                        <div className={styles.label}>
                                                            访视日程
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                    {
                                        // 一条时单页显示表单
                                        // item.forms && item.forms.length > 1 &&
                                        item.type !== 'SingleForm' &&
                                        <div className={styles.forms_content}>
                                            {
                                                item.forms && item.forms.map((formItem: any, index: any) => {
                                                    return (
                                                        <div key={index} className={styles.formItem} onClick={clickForm(item, formItem)}>
                                                            <div className={styles.borderLeft}>
                                                                {
                                                                    switchFormBorder(formItem)
                                                                }
                                                            </div>
                                                            <div className={styles.form_name}>
                                                                {formItem.name}
                                                            </div>
                                                            <div className={styles.state}>
                                                                {
                                                                    switchFormOcrState(formItem.ocrState)
                                                                }
                                                                {
                                                                    switchFormInputState(formItem.inputState)
                                                                }
                                                                {
                                                                    switchFormCheckState(formItem.checkState)
                                                                }
                                                                {
                                                                    switchFormQuestionState(formItem.questionState)
                                                                }
                                                                {
                                                                    switchFormExamineState(formItem.examineState)
                                                                }
                                                                {
                                                                    switchFormFreezeState(formItem.freezeState)
                                                                }
                                                                {
                                                                    switchFormAutographState(formItem.autographState)
                                                                }
                                                                {
                                                                    <FormUnlock onReload={()=> getFormsById(visitId)} formId={formItem.id} editModel={subjectsData.editModel} state={formItem.lockState}>
                                                                        {switchFormLockState(formItem.lockState)}
                                                                    </FormUnlock>
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            {/* <div className={styles.addFrom} onClick={addFormBtn(item)}>
                                        <IconFont type="iconAdd"></IconFont>添加表单
                                    </div> */}
                                            {
                                                item.forms.length == 0 && (
                                                    <Empty description='暂无表单信息'/>
                                                )
                                            }
                                        </div>
                                    }
                                </React.Fragment>
                            )
                        })
                    }

                    {/* 石药多恩达自定义表单 */}
                    {
                        visit.customize && (
                            <div className={styles.footerBtns}>
                                <Button onClick={()=> setVisibleCreateModal(true)} type="primary" size="small" inline>新增表单</Button>
                            </div>
                        )
                    }

                    {
                        visibleCreateModal && (
                            <CreateFormModal visitId={visit.id} onClose={()=> {
                                setVisibleCreateModal(false)
                                getFormsById(visit.id, subjectsData);
                            }}/>
                        )
                    }

                    {
                        subjectScaleReportState === 1 && (
                            <div className={styles.scales}>
                            {

                                selfReportedList.map((t)=> (
                                    <div className={styles.scale}>
                                        <h2>{t.name}</h2>
                                        <PatientSelfReported selfReportedList={t.scales} refresh={getFormsById} visitId={visitId} editModel={subjectsData.editModel}/>
                                    </div>
                                ))
                            }
                            </div>
                        )
                    }

                    <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />

                    <Modal visible={remarkModalShow} popup={true} animationType={'slide-up'} onClose={() => { setRemarkModalShow(false) }}>
                        <div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid rgb(146, 143, 143)', color: 'black' }}>
                                <div style={{ width: 'calc(100% - 1rem)', textAlign: 'center', paddingLeft: '1rem', fontSize: '0.426667rem', lineHeight: '1.066667rem' }}>添加备注</div>
                                <img style={{ width: '0.48rem', height: '0.48rem', margin: '0.26rem' }} onClick={() => { setRemarkModalShow(false) }} src={close} alt="关闭弹框" />
                            </div>
                            <div style={{ marginTop: '0.3rem' }}>
                                <Picker data={remarkTypeList} value={currentRemarkType} cols={1} className="forss" onOk={(value) => { setCurrentRemarkType(value) }}>
                                    <List.Item arrow="horizontal">备注类型</List.Item>
                                </Picker>
                            </div>
                            <div style={{ marginTop: '0.3rem' }}>
                                <InputItem
                                    placeholder="请输入备注内容"
                                    value={remarkValue}
                                    onChange={(value) => { setRemarkValue(value) }}
                                    style={{ textAlign: 'right', color: '#2A344D' }}
                                ><div>备注内容</div></InputItem>
                            </div>
                            <div style={{ marginTop: '0.3rem' }}>
                                <Picker data={isWarningList} value={remarkIsWarning} cols={1} className="forss" onOk={(value) => { setRemarkIsWarning(value) }}>
                                    <List.Item arrow="horizontal">是否警示</List.Item>
                                </Picker>
                            </div>
                            <div style={{ margin: '2rem 0.8rem 2rem 0.8rem' }}>
                                <Button style={{ backgroundColor: '#6287EC', borderRadius: '0.8rem' }} type="primary" onClick={onRemark}>确定</Button>
                            </div>
                        </div>
                    </Modal>
                

                    {
                        showVisitForm &&
                        <VisitForm ref={VisitFormRef} inPrePage={true} subjectsData={subjectsData} {...props}  />
                    }

                    {/* 操作按钮 */}
                    {
                        !showVisitForm &&
                        <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                            <img src={backBtn} alt="back" onClick={goBack} />
                        </div>
                    }

                    {showAcitonBtns()}
                    {/* {
                (subjectsData && subjectsData.signButtonState == 0 && subjectsData.auditState === "Fail") && showReSubmitBtn &&
                <div className={styles.btn_bottom} onClick={reSubmit}>重新提交审核</div>
            }

       
            {subjectsData.signButtonState == 1 &&
                <div className={styles.sign_btn_wrap}>
                    <Button className={styles.sign_btn} type="primary" onClick={onSignLaborAgreement}>
                        {subjectsData.signState == 'Pass' ? '已签署' : '未签署'}
                    </Button>
                </div>
            } */}
                </>
            }

            {/* 修改计划访视时间 */}
            <Modal
                visible={planModal}
                transparent
                maskClosable={true}
                onClose={() => setPlanModal(false)}
                title="修改计划访视时间"
                footer={[
                    {
                        text: '修改',
                        onPress: () => {
                            setPlanModal(false)
                            setShowPlanModal(true)
                            getRemainingVisits()
                        }
                    },
                ]}
            >
            <div >
                <DatePickerView
                    mode="date"
                    value={currentPlanDate}
                    format={'YYYY-MM-DD'}
                    onChange={(value) => { setCurrentPlanDate(value) }}
                />
            </div>
            </Modal>

            {/* 计划访视日期时间修改 */}
            <Modal
                visible={showPlanModal}
                title={`此次访视后还有${remainingVisits}次访视，是否同步计划访视日期`}
                transparent
                maskClosable={true}
                onClose={() => setShowPlanModal(false)}
                footer={[
                    {
                        text: '否',
                        onPress: () => {
                            setShowPlanModal(false)
                            // 触发另一个回调
                            handleConfirm(currentPlanDate, 0)
                        }
                    },
                    {
                        text: '是',
                        onPress: () => {
                            setShowPlanModal(false)
                            handleConfirm(currentPlanDate, 1)
                        }
                    }
                ]}
            >

            </Modal>

            {/* 修改实际访视时间 */}
            <Modal
                visible={visitModal}
                transparent
                maskClosable={true}
                onClose={() => setVisitModal(false)}
                title="修改实际访视时间"
                footer={[
                    {
                        text: '修改',
                        onPress: () => {
                            setVisitModal(false);
                            let params = {
                                visitDate: moment(currentVisitDate).format('YYYY-MM-DD'),
                                visitId
                            }
                            setLoading(true);

                            api.modifyVisitDate(params).then(res => {
                                if (res.code == '0') {
                                    Toast.success('修改成功！', 1)
                                    //更新数据
                                    getFormsById(visitId);
                                    initData();
                                }
                                else {
                                    if (res.message) {
                                        Toast.fail(res.message, 1)
                                    }
                                    else {
                                        Toast.fail('修改失败！', 1)
                                    }
                                }
                                setLoading(false);
                            })
                        }
                    },
                ]}
            >
                <div >
                    <DatePickerView
                        mode="date"
                        value={currentVisitDate}
                        onChange={(value) => { setCurrentVisitDate(value) }}
                    />
                </div>
            </Modal>


            <Modal visible={showUploadModal} className={styles.upload_container}>
                <div className={styles.upload_content}>
                    <div className={styles.upload_item}>
                        <img src={fileIcon} alt="" />
                        <span>{fileName?fileName:'本地文件'}</span>
                        <input
                            type="file"
                            className={styles.upload_input}
                            id="takeFile"
                            onChange={() => onUpload('takeFile')}
                            accept=".pdf"
                        />
                  
                    </div>
                    {/* <div className={`${styles.upload_item} ${styles.album}`}>
                        <img src={imgIcon} alt="" />
                        <span>本地相册</span>
                        <input
                            className={styles.upload_input}
                            type="file"
                            id="takeImage"
                            onChange={() => onUpload('takeImage')}
                            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                        />
                    </div>*/}
                    <div className={`${styles.upload_item} ${styles.camera}`}>
                        <img src={cameraIcon} alt="" />
                        <span>拍照</span>
                        <input
                            className={styles.upload_input}
                            type="file"
                            id="takeCamera"
                            capture="camera"
                            onChange={() => onUpload('takeCamera')}
                            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                        />
                    </div> 
                    <div className={styles.closeBtn}>
                        <div  onClick={() => handleCloseModal()}>关闭</div>
                        <div  onClick={() => handleSign()}>确定</div>
                    </div>
                
                </div>
            </Modal >


            <Modal visible={showCaseImage} animationType={"slide-up"} className={styles.case_container}>
                <div className={styles.case_content}>
                    <div className={styles.imgBox}>
                        {caseFileType == 'pdf' ? <Document file={caseImageUrl} onLoadSuccess={({numPages}: any) => {onDocumentLoadSuccess(numPages)}}>
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    renderAnnotationLayer={false}
                                    renderTextLayer={false}
                                />
                                ))}
                        </Document> : <img src={caseImageUrl} alt="" />}

                    </div>
                    <div className={styles.closeBtn} onClick={() => setShowCaseImage(false)}>关闭</div>
                </div>
            </Modal>

            <Modal visible={showEmailModal} className={styles.email_container}>
                <div className={styles.email_content}>
                    <img className={styles.email_icon} src={email_icon} alt="" />
                    <ul className={styles.fields}>
                        <li className={styles.item}>
                            <div className={styles.etitle}>方式一：将病例发送到以下邮箱</div>
                            <div className={styles.ebody}>
                                <input type="text" placeholder="请输入邮箱地址" value={emailAddress} onChange={(event) => { changeEmail(event) }} />
                                <div className={styles.btn} onClick={handleSendEmail}>发送</div>
                            </div>
                        </li>
                        <li>
                            <div className={styles.etitle}>方式二：将病例下载到手机</div>
                            <div className={styles.ebody}>
                                <input onClick={ handCopyURL } type="text" value={casePreviewUrl} readOnly />
                                <div className={styles.btn} onClick={handleDownloadCase}>下载</div>
                            </div>
                        </li>
                    </ul>
                    <div className={styles.btns}>
                        <div className={styles.cancelBtn} onClick={closeEmail}>取消</div>
                    </div>
                </div>
            </Modal>
            <Modal visible={rejectReasonModal} className={styles.reason_container}>
                <div className={styles.reason_content}>
                    <div className={styles.title}>不合格原因</div>
                    <div className={styles.content}>
                        <ul>
                            {
                                rejectReasonList.map((v: any, i: number) => {
                                    return (<li key={i}>{v}</li>)
                                })
                            }
                        </ul>
                    </div>
                    <div className={styles.footer} onClick={() => setRejectReasonModal(false)}>我知道了</div>
                </div>
            </Modal>
            {/* 受试者转移 */}
            <TransoutModal
                visible={transoutModalVisible}
                projectId={projectId}
                subjectCode={subjectCode}
                onClose={()=> setTransoutModalVisible(false)}/>
        </div >
    )
}


export default SubjectsDetail;
